<div class='selectionContainer'>
  <div *ngIf='filters'>
    <div class='text-center mb-2' [innerHTML]="'campaign.filter.preMessage' | translate"></div>
    <div *ngFor='let filterEntry of filters; let i=index' class='mb-3 row'>
      <div>
        <strong class='me-2' style="vertical-align: top" [innerHTML]="'campaign.filter.message' | translate: { 'option': filterEntry.key}"></strong>
      </div>
      <div class="thumbnailColumn col-sm-4" *ngFor='let option of filterEntry.options; let j=index' (click)="selectedFilter === option;handleFilterSelection(option)">
        <div class='thumbnailEntry' [ngClass]="{'itemSelected': option === selectedFilter}">
          <label class="caption">
            <div class='float-end selectorIconContainer'>
              <span *ngIf='selectedFilter === option' class='selectedIcon fa-regular fa-square-check'></span>
              <span *ngIf='selectedFilter !== option' class='unselectedIcon fa-regular fa-square'></span>
            </div>
            <input class='btn-check' type='radio' name='filterOption' [id]="'option_'+i+'_'+j"
                   [checked]='selectedFilter === option'
                   (change)='handleFilterSelection(option)'>
            <strong [innerHTML]="option.value"></strong>
            <div *ngIf="option.description" [innerHTML]="option.description" class="small"></div>
          </label>
        </div>
      </div>
    </div>
  </div>
  <div class='row'>
    <div *ngIf='products.length > 0'>
      <div class='text-center mb-2' [innerHTML]="'campaign.filter.postMessage' | translate"></div>
    </div>
    <div *ngFor='let product of products' class='col-sm-4 thumbnailColumn'>
      <div class='thumbnailEntry' [ngClass]="{'itemSelected': product.id === selectedProductId}" (click)='selectedProductId = product.id;onProductChange(product)'>
        <input type='radio' class='btn-check' id='{{ product.id }}' name='product'
               [checked]='product.id === selectedProductId'
               value='{{ product.id }}' (change)='onProductChange(product)'
               [disabled]='!campaignDraft.layouts || campaignDraft.rejectedAdverts().length'
        />
        <label class='caption'>
          <div class='float-end selectorIconContainer'>
            <span *ngIf='product.id === selectedProductId' class='selectedIcon fa-regular fa-square-check'></span>
            <span *ngIf='product.id !== selectedProductId' class='unselectedIcon fa-regular fa-square'></span>
          </div>
          <h3>
            {{ product.name }}
          </h3>
          <p *ngIf='product.description'>{{ product.description }}</p>
          <p *ngIf='product.thumbnailUrl'><img *ngIf='product.thumbnailUrl' [src]='product.thumbnailUrl' class='layoutThumbnail' alt='' /></p>
          <div *ngIf="productImageTranslations[product.id]">{{productImageTranslations[product.id]}}</div>
          <div *ngIf="!productImageTranslations[product.id]"
            [innerHTML]="'campaign.product.adDesignChoice' | translate: { count: product.layouts.length }"
          ></div>
          <div class='mb-3'>
            <div *ngIf="!productNative[product.id]">
              <span *ngFor='let dim of product.allowedDimensions' class='badge bg-primary me-1'>
                {{ dim[0] }}x{{ dim[1] }}
              </span>
            </div>
          </div>
          <div *ngIf='!product.data.presentationOptions?.hideCpm && product.minimumCpc?.amount'
               [innerHTML]="'campaign.product.cpc' | translate: { value: i18nFormatService.currency(product.minimumCpc) }"
          ></div>
          <div *ngIf='!product.data.presentationOptions?.hideCpm && product.minimumCpm?.amount'
               [innerHTML]="'campaign.product.cpm' | translate: { value: i18nFormatService.currency(product.minimumCpm) }"
          ></div>
          <div
            *ngIf='product.minimumBudget'
            [innerHTML]="
              'campaign.product.minSpend' | translate: { value: i18nFormatService.currency(product.minimumBudget) }
            "
          ></div>
          <div
            *ngIf='product.maximumBudget'
            [innerHTML]="
              'campaign.product.maxSpend' | translate: { value: i18nFormatService.currency(product.maximumBudget) }
            "
          ></div>
          <ng-container *ngIf="campaignDraft.signUpCoupons">
            <ng-container *ngFor="let coupon of campaignDraft.signUpCoupons.results">
              <span *ngIf="couponHasProduct(coupon, product)">
                <span *ngIf="coupon.type === 'PERCENTAGE'" class="badge bg-success mt-2 me-1">{{coupon.discountPercentage / 100 | percent }} discount available</span>
                <span *ngIf="coupon.type === 'MONETARY'" class="badge bg-success mt-2 me-1">{{i18nFormatService.currency(coupon.discountMonetary)}} discount available</span>
              </span>
            </ng-container>
          </ng-container>
        </label>
      </div>
    </div>
  </div>
  <div *ngIf='campaignDraft.rejectedAdverts().length' class='row mb-4'>
    <div>
      {{ 'campaign.adRejected.productUnchanged' | translate }}
    </div>
  </div>
</div>
